export const editorMixin = {
  methods: {
    handleAction(e, action, callback) {
      if (this.$store.state.editorIsDemoVersion) {
        this.$store.commit("showEditorDemoCTA", { y: e.clientY, x: e.clientX, action });
        return;
      } else {
        typeof callback == "function" ? callback() : callback;
      }
    },

    getSentenceTypePrettyName(sentenceType) {
      switch (sentenceType) {
        case "Sectionbreak":
          return this.$t("sentence-types.section-break");
        case "Linebreak":
          return this.$t("sentence-types.line-break");
        case "NewParagraph":
          return this.$t("sentence-types.new-paragraph");
        case "TableCell":
          return this.$t("sentence-types.table-cell");
        case "TableHeaderCell":
          return this.$t("sentence-types.table-header-cell");
        case "TableHeaderRow":
          return this.$t("sentence-types.table-header-row");
        case "TableRow":
          return this.$t("sentence-types.table-row");
        case "Table":
          return this.$t("sentence-types.table");
        case "UnorderedList":
          return this.$t("sentence-types.unordered-list");
        case "OrderedList":
          return this.$t("sentence-types.ordered-list");
        case "ListItem":
          return this.$t("sentence-types.list-item");
        default:
          return this.$t("sentence-types.sentence");
      }
    }
  }
};
